import Image from 'next/image'
import Link from 'next/link'

import { BlockCall } from 'types/block-call'

interface MediaSectionProps {
  data: BlockCall[]
}

export const MediaSection = ({ data }: MediaSectionProps) => {
  return (
    <section
      id="media-section"
      className="w-full snap-always snap-start pt-14 px-4 md:px-8"
    >
      <div className="w-full max-w-7xl mx-auto">
        <h3 className="w-full text-2xl md:text-[35px] leading-[30px] lg:text-[30px] lg:leading-[35px] 2xl:text-[35px] tracking-[-2.5%] text-v3-gray-600 lg:text-left lg:relative lg:top-0 lg:w-full lg:px-0">
          Portal Solar na mídia
        </h3>
        <span className="block text-xs text-v3-gray-200 font-medium tracking-[0.16em] leading-9 uppercase md:text-base md:mt-3">
          Estamos na
        </span>

        <div className="flex flex-col items-center justify-center gap-4 xl:gap-8 p-4 mt-2 border border-v3-gray-100 rounded-lg md:flex-row md:mt-2 md:p-6">
          {data &&
            data.length > 0 &&
            data.map((item, index) => (
              <Link
                key={index}
                href={item.buttonLink}
                aria-label={item.title}
                target="_blank"
                rel="nofollow"
                className="hover:bg-v3-gray-75 transition duration-300"
              >
                <Image
                  width={265}
                  height={88}
                  alt={item.imageAlt}
                  src={item.imageUrl}
                  loading="lazy"
                />
              </Link>
            ))}
        </div>
      </div>
    </section>
  )
}
